import React, { useState, useMemo } from "react";

import BulkRequestDestroyEmployeeTable from "./table";
import { fetchCustomFieldValue, isAuthorizedCustomFieldToUser } from "../../../../helper/custom_field/helper";

import { create as createBulkRequestDestroyEmployee } from "../destroy_employee/axios";

const LaboralBulkRequestDestroyEmployeeForm = props => {
  const {
    currentCustomer,
    currentUser,
    data: {
      customFields,
      securityLayers,
    }
  } = props;

  const [bulkRequest, setBulkRequest] = useState(props?.bulkRequest);

  const hiringStateOptions = [{ value: 'active', label: I18n.t('laboral.hirings.index.tabs.active') }, { value: 'expired', label: I18n.t('laboral.hirings.index.tabs.expired') }]

  const tableColumnSecurityLayer = useMemo(() => {
    if (currentCustomer.security_layer && securityLayers?.length > 0) {
      return {
        field: `security_layer.name`,
        header: I18n.t("activerecord.attributes.laboral/employee.security_layer_id"),
        body: (row) => row?.security_layer?.name || I18n.t('no_entry'),
        filter: {
          enabled: true,
          placeholder: 'Seleccione una capa de seguridad',
          inputType: 'simple_select',
          options: _.map(securityLayers, securityLayer => ({
            value: securityLayer.id,
            label: securityLayer.name,
          })),
        }
      }
    }
  })

  const tableColumnsDefault = [
    {
      field: "identifier",
      header: I18n.t("activerecord.attributes.laboral/employee.identifier"),
      body: (row) => row?.identifier || I18n.t('no_entry'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el identificador',
        inputType: 'text',
        filterrific: {
          search: 'search_by_identifier'
        }
      }
    },
    {
      field: "employee_config.name",
      header: I18n.t("activerecord.attributes.laboral/employee.name"),
      body: (row) => row?.employee_config?.name || I18n.t('no_entry'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el nombre',
        inputType: 'text',
        filterrific: {
          search: 'search_by_employee_name'
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'name_'
        }
      }
    },
    {
      field: "employee_config.email",
      header: I18n.t("activerecord.attributes.laboral/employee.email"),
      body: (row) => row?.employee_config?.email || I18n.t('no_entry'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el correo electrónico',
        inputType: 'text',
        filterrific: {
          search: 'search_query'
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'email_'
        }
      }
    },
    {
      field: "created_at_to_s",
      header: I18n.t("activerecord.attributes.laboral/employee.created_at"),
      body: (row) => row?.created_at_to_s || I18n.t('no_entry'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese la fecha de creación',
        inputType: 'text',
        filterrific: {
          search: 'search_by_created_at'
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'created_at_'
        }
      }
    },
    {
      field: "has_hiring_active",
      header: I18n.t("activerecord.attributes.laboral/employee.hiring_status"),
      body: (row) => row?.has_hiring_active ? I18n.t("laboral.employees.show.active_hiring") : I18n.t("laboral.employees.show.inactive_hiring"),
      filter: {
        enabled: true,
        placeholder: 'Seleccione un estado de contratación',
        inputType: 'simple_select',
        options: hiringStateOptions,
        filterrific: {
          search: 'by_hiring_state'
        }
      },
    }
  ]

  const tableColumnsCustomFields = useMemo(() => {
    return _.map(customFields, function (customField) {
      return {
        field: `custom_fields.${ customField.code }`,
        header: _.capitalize(customField.label),
        body: (row) => {
          return fetchCustomFieldValue(customField, row.custom_fields[customField.code], currentUser)
        },
        filter: {
          enabled: isAuthorizedCustomFieldToUser(customField, currentUser),
          placeholder: `Ingrese ${ _.capitalize(customField.label) }`,
          filterrific: {
            search: `search_by_key_custom_fields`,
            searchKey: customField.code
          }
        },
        configuration: {
          isCustomField: true
        }
      }
    })
  }, [customFields])

  const tableColumns = useMemo(() => {
    let columns = _.concat(
      tableColumnSecurityLayer,
      tableColumnsDefault,
      tableColumnsCustomFields
    )

    return _.compact(columns)
  }, [])

  return (
    <div>
      <BulkRequestDestroyEmployeeTable
        bulkRequest={bulkRequest}
        setBulkRequest={setBulkRequest}
        dataTableConfiguration={{
          columns: tableColumns
        }}
        configuration={{
          formName: 'laboral_bulk_request_destroy_employee',
        }}
        routes={{
          indexEmployeesPath: Routes.laboral_employees_path,
          indexBulkRequestPath: Routes.laboral_bulk_request_destroy_employees_path,
          showBulkRequestPath: Routes.laboral_bulk_request_destroy_employee_path,
        }}
        services={{
          createService: createBulkRequestDestroyEmployee,
        }}
      />
    </div>
  )
}

export default LaboralBulkRequestDestroyEmployeeForm;
